import { translateFn } from '../../../../../../../utils/translator.helper';
import { RelayUpdateLocationItem } from '@nirvana/shared/dtos/types/policies/common';
import { RequiredValidator } from '../../../../../../../ui/gzForm/validators/required.validator';
import { FormValidator, ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';
import { AddressValidator } from '../../../../../../../ui/gzForm/validators/address.validator';

// get validators for server field
export const serverValidators = (): FormValidator<string>[] => {
  return [RequiredValidator(translateFn('Required field')), AddressValidator(translateFn('Invalid host address'))];
};

// validate duplicates
export function validateDuplicates(
  locationItem: RelayUpdateLocationItem,
  locationsInGrid: RelayUpdateLocationItem[]
): ValidationResult {
  const hasDuplicates = locationsInGrid.some(
    (locationInGrid: RelayUpdateLocationItem) =>
      locationInGrid.useProxy === locationItem.useProxy && locationInGrid.server === locationItem.server
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
